<template>
  <div class="loginAll">
    <div class="login" v-html="agreementInfo">
      
    </div>
  </div>
</template>

<script>
  // 引入共用的css
	import "../components/css/component.css";
  import "../components/css/input.css";

  // 调用的接口
  import { getAgreement, getCancelAgreement } from '@/request/api.js';
  
  export default {
    name: 'agreement',
    data () {
      return {
        agreementInfo: ''
      }
    },

    mounted() {
      // 获取协议
      this.getAgreementDetail();
    },

    computed:{
      
    },

    methods:{
      // 获取协议
      getAgreementDetail() {
        // 判断用户协议还是隐私协议：0：用户 1：隐私
        var code = localStorage.getItem('agreementCode');
        if(parseInt(code) === 0) {
          // 调用用户协议接口
          getAgreement().then(res => {
            if(res.code === 0) {
              this.agreementInfo = res.data.content;
            }
          })
        }else if(parseInt(code) === 1) {
          // 调用隐私协议接口
          getCancelAgreement().then(res => {
            if(res.code === 0) {
              this.agreementInfo = res.data.content;
            }
          })
        }
      }
    }
  }
</script>

<!-- 样式 -->
<style scoped lang="scss">
  .loginAll {
    min-width: 1200px;
    // 框
    .login {
      width: 1200px;
      margin: 0 auto;
      text-align: justify;
      padding: 30px 0;
      &p {
        line-height: 22px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/agreement.vue